export const Settings = new (class {
  set(settings) {
    Object.entries(settings).forEach(([key, value]) => {
      this[key] = value
    })
  }
})()
